import InfoCsvExportButton from "../../components/InfoCsvExportButton.js";
import { ownerPopulationCsv } from "../../utils/info-report-csv.js";
import { memo, useState } from "react";
import Spinner from "../../components/Spinner.js";
import SelectOwnerForm from "../../components/forms/OwnerSelect.js";
import { useSnackbar } from "../../utils/index.js";
import { getOwnerPopulation } from "../../api/index.js";
import OwnerPopulationPdf from "../../components/info-pdfs/OwnerPopulation.js";


const OwnerPopulation = () => {
    const [selectedOwner, setSelectedOwner] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [fetchedAlive, setFetchedAlive] = useState([]);
    const [fetchedDead, setFetchedDead] = useState([]);
    const [step, setStep] = useState(1);
    const [selectedYear, setSelectedYear] = useState(null);

    const { error } = useSnackbar();

    const fetchOwnerPopulation = async (selOwner, year) => {
        setIsLoading(true);
        try {
            const { success: scs, aliveAnimals, deadAnimals, message } = await getOwnerPopulation(selOwner, year);
            if (scs) {
                setFetchedAlive(aliveAnimals);
                setFetchedDead(deadAnimals);
                setSelectedYear(year);
                setStep(2);
            } else {
                error(message);
            }
        } catch (err) {
            error(err);
        }
        setIsLoading(false);
    }

    return (
        <>
            <Spinner open={isLoading} />
            {step === 1 && (
                <SelectOwnerForm
                    setSelectedOwner={setSelectedOwner}
                    title={"Καρτέλα Απογραφής"}
                    method={fetchOwnerPopulation}
                    screenCase={"OwnerPopulation"}
                />
            )}
            {step === 2 && (
                <>
                    <InfoCsvExportButton filename={`apografi_${selectedOwner?.code || "ektrofi"}_${selectedYear}`}
                        getRows={() => ownerPopulationCsv(selectedOwner, selectedYear, fetchedAlive, fetchedDead)} disabled={!fetchedAlive?.length && !fetchedDead?.length} />
                    <OwnerPopulationPdf
                        selectedOwner={selectedOwner}
                        aliveAnimals={fetchedAlive}
                        deadAnimals={fetchedDead}
                        selectedYear={selectedYear}
                    />
                </>
            )}
        </>
    )
}

export default memo(OwnerPopulation)